import React from "react";

import { useHierarchyService } from "../../hooks/useHierarchyService";
import { Allergy } from "../../constants/ProIcons";
import _ from 'lodash'

const ProClientAllergy = ({index, assignment, performAction, totalAssignments})=>{
  
    const {data:{selectedTreeNode}} = useHierarchyService();
    const node = selectedTreeNode;
   
     if(_.get(assignment.occupantType, "code") === "CLIENT" && _.get(assignment.client, "hasClientAllergy")){
            return  <div id={`Allergy-${assignment.assignmentId}`} className={_.gt(totalAssignments, 1)?_.isEqual(index+1, totalAssignments)?"p-mb cursor-pointer" :"p-mb-1 cursor-pointer":"p-mb cursor-pointer"} >
                    <i aria-hidden="true" className ={assignment.latestAssignment?"fas": "fas icon-opacity-low"} 
                     style={{ color: 'green', fontSize: 14, position: 'relative' }} onClick={()=>performAction(node, assignment, "CLIENT_ALLERGY", 'Client Allergies', 'bottom')}>
                    <Allergy/>
                </i>
            </div> 
        }else {            return <div id={`Allergy-${assignment.assignmentId}`} className="p-mb-5" ></div>
        }        
   

}

export default ProClientAllergy;